module.exports = __webpack_public_path__ + "static/android-icon-192x192-309ba444c01e89ad9e8eea610278859e.png";